import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import VueTilt from 'vue-tilt.js'; 

Vue.config.productionTip = false
Vue.use(VueTilt)
new Vue({
  router,
  vuetify,
  VueTilt,
  render: h => h(App)
}).$mount('#app')
